export default __webpack_public_path__ + "static/media/ProgrammableSplitter.64.c729f497.png";